/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import { SuccessButton, SuccessButtonWhiteBg } from 'components/button';
import styled from 'styled-components';
import {
	exploreAllMintPacks,
	gotoKnowMore,
	isBtoCFlow,
} from '__utils/common-utils';
import { CommonStyledComponentProps, LearnBusinessType } from '__utils/type';
import { learnBusinessList } from './home-constants';
import VideoPlayerPopup from 'components/video-player-popup';
import SipCalcImage from 'images/sip-calc.svg';
import GoalAmountImage from 'images/target-amount-calc.svg';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import './index.css';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import GreaterIcon from '../../assets/icons/greater-than-icon/index';
import { Mixpanel } from '__utils/mixpanel';
import { getEventName } from '../../__utils/mixpanel';
import MintpacksCard from 'views/all-mintpacks/mint-packs-card';
import RenderViewSelector from 'views/render-view/renderView.selector';
import carouselBtn from 'images/carousel-btn.png';
import userSelector from 'views/user/user.selector';

export const WhiteGreenBorderBtn = styled(SuccessButtonWhiteBg)<
	CommonStyledComponentProps
>`
	width: 100px;
	font-size: 14px;
`;

export const CalculatorContainer = styled.div<CommonStyledComponentProps>`
	.calc-top h4 {
		color: #121617;
		font-size: ${(props) => (props.isMobile ? '18px' : '20px')};
		font-weight: bold;
		line-height: 24px;
		padding-bottom: 10px;
	}

	.calc-top p {
		color: #121617;
		font-size: ${(props) => (props.isMobile ? '14px' : '16px')};
		line-height: 19px;
	}
	.calc-top::after {
		width: ${(props) => (props.isMobile ? '120px' : '170px')};
		height: ${(props) => (props.isMobile ? '120px' : '170px')};
		top: ${(props) => (props.isMobile ? '-40px' : '-70px')};
	}
	.mint-head {
		font-weight: ${(props) => (props.isMobile ? '500' : '400')};
	}
	.txt-sec {
		padding-right: ${(props) => (props.isMobile ? '40px' : '20px')};
	}
	.item1 {
		grid-area: header;
	}
	.item2 {
		grid-area: menu;
	}
	.item3 {
		grid-area: main;
	}
	.item4 {
		grid-area: right;
	}
	.item5 {
		grid-area: footer;
	}

.grid-container {
		display: grid;
		grid-template-areas:
			'header header header header header header'
			'menu main main main right right'
			'menu footer footer footer footer footer';
		gap: 10px;
		background-color: #2196f3;
        padding: 10px;
}

.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 20px 0;
  font-size: 30px;
}
`;


export const LearnMFBusinessComponent = () => {
	const { countTotalAUM } = propsToJS(useSelector(userSelector));

	const goToMintAcademyClick = () => {
		window.location.assign(
			'https://app.mintpro.in/vertical-redirect/lms?redirect=/branches/52478614778524/courses/5450657758707712'
		);
		Mixpanel.track(getEventName('goToMintAcademy', 'clicked', 'home'));
	};

	return (
		<div className="mint-box mb16 mt16">
			<div className="mint-flex p0">
				<p className="infoVideoTitleMain">
					Learn Mutual Funds Business
				</p>
			</div>
			{/* (index !== 0 || (index === 0 && countTotalAUM?.customerCount >= 2)) && */}
			<div className="pt16 p16">
				{learnBusinessList.map(
					(video: LearnBusinessType, index: number) => (
						<div key={index}>
							{(index !== 0 ||
								(index === 0 &&
									countTotalAUM?.customerCount >= 2)) && (
								<div
									className={`info-video-main ${
										index === 0 ? 'info-video-border' : ''
									}`}
								>
									<VideoPlayerPopup
										key={index}
										index={index}
										thumbnailImg={video.icon}
										videoSrc={video.videoSrc}
									/>
									<div
										className={`pl16 ${
											index === 0 && 'pt16'
										}`}
									>
                                        <div className='hello'>trting out a popup</div>
                                        <div>
                                            <div className="item1">Header</div>
                                            <div className="item1">Menu</div>
                                        </div>
										<div className="video-title">
											{video.videoTitle}
										</div>
										<div className="video-description">
											{video.videoDesc}
										</div>
										{index === 0 && (
											<div
												className="exploreAll mt24"
												onClick={gotoKnowMore}
											>
												Learn about earning potential{' '}
												<GreaterIcon color="#00a645" />
											</div>
										)}
									</div>
								</div>
							)}
						</div>
					)
				)}
			</div>

			<div className="exploreAll p16 ft14" onClick={goToMintAcademyClick}>
				Explore all Learning Content <GreaterIcon color="#00a645" />{' '}
			</div>
		</div>
	);
};

export const CalculatorSection = () => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const history = useHistory();

	return (
		<CalculatorContainer isMobile={isMobile}>
			<div className={`calc-sec p16 ${isMobile ? 'm16 mt30' : ''}`}>
				<div
					className={`calc-top ${
						isMobile ? 'calc-mobile' : 'calc-desktop'
					}`}
				>
					<h4>Investment Calculators</h4>
					{isBtoCFlow() ? (
						<p className="m0">
							Invest smartly by using our calculators to achieve
							your financial goals.
						</p>
					) : (
						<p>
							Increase your sales by sharing personalised
							calculations for your client's financial goals.
						</p>
					)}
				</div>
				<Row gutter={32}>
					<Col xs={24} md={9}>
						<div
							className={`calc-card ${
								isMobile ? 'rowFlex' : 'calc-list'
							}`}
							onClick={() => history.push('sip-calculator')}
						>
							<div className="img-sec">
								<img src={SipCalcImage} alt="" />
							</div>
							<div className="txt-sec txt-sec-calc">
								<h5>SIP Calculator</h5>
								<p>
									{isBtoCFlow()
										? 'Plan your monthly investments and know your future wealth'
										: "Plan your client's monthly investments and help them know the future wealth"}
								</p>
							</div>
						</div>
					</Col>
					<Col xs={24} md={9}>
						<div
							className={`calc-card ${
								isMobile ? 'rowFlex mt16' : 'calc-list'
							}`}
							onClick={() =>
								history.push('goal-amount-calculator')
							}
						>
							<div className="img-sec">
								<img src={GoalAmountImage} alt="" />
							</div>
							<div className="txt-sec txt-sec-calc">
								<h5>Goal Amount Calculator</h5>
								<p>
									{isBtoCFlow()
										? 'Use our calculator to see how much you need to save to reach your financial goals.'
										: 'Use our calculator to see how much your client needs to save to reach their financial goals.'}
								</p>
							</div>
						</div>
					</Col>
				</Row>
			</div>
		</CalculatorContainer>
	);
};

export const BestSellingMintpacks = () => {
	const isMobile = useMediaQuery({ maxWidth: 767 });
	const { recommedndedMintpacks } = propsToJS(
		useSelector(RenderViewSelector)
	);
	const recommendedMintPacksList = recommedndedMintpacks?.map((ele: any) => {
		return { ...ele, showDescription: false };
	});

	let carouselPosition = document.getElementById(
		'bestseller-mintpacks-carousel'
	) as HTMLInputElement;
	const scrollCarouselLeft = () => {
		carouselPosition.scrollLeft -= 350;
	};
	const scrollCarouselRight = () => {
		carouselPosition.scrollLeft += 350;
	};

	return (
		<div className={isMobile ? 'mint-box mb30' : `fullContainer mb44`}>
			<div className="wrapper mint-grid">
				<Row
					gutter={!isMobile ? 32 : 0}
					style={{ flexDirection: isMobile ? 'column' : 'row' }}
				>
					<Col xs={24} md={7}>
						<>
							<p className="mint-head p0">Mintpacks </p>
							<div>
								<p className="mint-small-text">
									Collection of mutual funds selected by our
									experts to help you meet your life goals.
								</p>
								{!isMobile && (
									<div
										className={`mint-btn ${
											isMobile ? '' : 'mr100'
										}`}
									>
										<SuccessButton
											onClick={exploreAllMintPacks}
										>
											Explore All Mintpacks
										</SuccessButton>
									</div>
								)}
							</div>
						</>
					</Col>
					<Col xs={24} md={17}>
						{!isMobile && (
							<p className="best-selling-title">
								Best Selling Mintpacks
							</p>
						)}
						<div
							className="best-mintpack-wrap top-carouse"
							id="bestseller-mintpacks-carousel"
						>
							{
								<MintpacksCard
									mintPackList={recommendedMintPacksList}
								/>
							}
						</div>

						{isMobile && (
							<div
								className="exploreAll ft14 generateInvest"
								onClick={exploreAllMintPacks}
							>
								<p>Explore all Mintpacks </p>
								<GreaterIcon color="#00a645" />
							</div>
						)}
						{!isMobile && (
							<>
								<div
									className="left-icon"
									onClick={scrollCarouselLeft}
								>
									<img src={carouselBtn} />
								</div>
								<div
									className="right-icon"
									onClick={scrollCarouselRight}
								>
									<img src={carouselBtn} />
								</div>
								<div className="white-shadow" />
								<div className="white-shadow ws-left" />
							</>
						)}
					</Col>
				</Row>
			</div>
		</div>
	);
};
